import React from 'react';
import './DateFilterInput.css';

/** A date-only filter with an explicit native calendar action and typed entry. */
export default function DateFilterInput({ label, value, onChange }: {
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [pickerDenied, setPickerDenied] = React.useState(false);
  const canOpenPicker = !pickerDenied && typeof HTMLInputElement !== 'undefined'
    && typeof HTMLInputElement.prototype.showPicker === 'function';

  function openCalendar() {
    const input = inputRef.current;
    if (!input) return;
    input.focus();
    // Browser policy can deny showPicker in an embedded frame. Typed entry and
    // the native indicator remain available if that happens.
    try { input.showPicker(); } catch { setPickerDenied(true); input.focus(); }
  }

  return (
    <div className="date-filter-input">
      <input ref={inputRef} type="date" aria-label={label} value={value}
        onChange={event => onChange(event.target.value)} />
      {canOpenPicker ? (
        <button type="button" className="btn subtle date-filter-input__calendar"
          aria-label={`Open calendar for ${label.toLowerCase()}`} title={`Choose ${label.toLowerCase()}`}
          onClick={openCalendar}>
          <svg viewBox="0 0 20 20" width="16" height="16" fill="none" aria-hidden="true">
            <rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
            <path d="M6 2v4m8-4v4M3 8h14" stroke="currentColor" strokeWidth="1.5" />
          </svg>
        </button>
      ) : null}
    </div>
  );
}
